/**
 * Validation panier bracelet personnalisé
 * Supprime automatiquement les suppléments pierres orphelins
 * quand le bracelet principal est retiré du panier.
 */
(function() {
  'use strict';

  var isValidating = false;
  var validateTimer = null;

  function validateCart(shouldReload) {
    if (isValidating) return;
    isValidating = true;

    console.log('[BRACELET-VALID] Checking for orphaned supplements...');

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var groups = {};

        cart.items.forEach(function(item) {
          var group = null;
          if (item.properties && item.properties._bracelet_group) {
            group = item.properties._bracelet_group;
          }
          if (!group) return;

          if (!groups[group]) {
            groups[group] = { bracelet: null, supplements: [] };
          }

          if (item.handle === 'supplement-pierre-bracelet') {
            groups[group].supplements.push({ key: item.key });
          } else {
            groups[group].bracelet = { key: item.key };
          }
        });

        // Collecter tous les suppléments orphelins
        var updates = {};
        var hasOrphans = false;
        Object.keys(groups).forEach(function(groupId) {
          var g = groups[groupId];
          if (!g.bracelet && g.supplements.length > 0) {
            console.log('[BRACELET-VALID] Found ' + g.supplements.length + ' orphaned supplements in group ' + groupId);
            g.supplements.forEach(function(s) {
              updates[s.key] = 0;
            });
            hasOrphans = true;
          }
        });

        if (!hasOrphans) {
          console.log('[BRACELET-VALID] No orphans found');
          isValidating = false;
          return;
        }

        console.log('[BRACELET-VALID] Removing orphaned supplements...');

        // Supprimer les suppléments orphelins
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function() {
          console.log('[BRACELET-VALID] Orphans removed, triggering UI refresh');
          isValidating = false;

          if (shouldReload) {
            window.location.reload();
          } else {
            // Dispatcher cart:update pour que le thème morph le cart drawer
            // ET que cart-drawer-legacy.js re-vérifie le seuil cadeau
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: {}, sourceId: 'bracelet-validation' }
            }));
          }
        })
        .catch(function(e) {
          console.error('[BRACELET-VALID] Error removing orphans:', e);
          isValidating = false;
        });
      })
      .catch(function(e) {
        console.error('[BRACELET-VALID] Error fetching cart:', e);
        isValidating = false;
      });
  }

  function scheduleValidation(shouldReload) {
    clearTimeout(validateTimer);
    validateTimer = setTimeout(function() {
      validateCart(shouldReload);
    }, 700);
  }

  // 1. Valider au chargement de la page /cart
  if (window.location.pathname === '/cart') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { validateCart(true); });
    } else {
      validateCart(true);
    }
  }

  // 2. Écouter cart:update (dispatché par le thème après chaque changement)
  //    Le thème dispatch cet événement après morphSection, c'est le plus fiable
  document.addEventListener('cart:update', function(e) {
    // Ne pas re-valider si c'est nous qui avons dispatché
    if (e.detail && e.detail.sourceId === 'bracelet-validation') return;
    console.log('[BRACELET-VALID] cart:update detected, scheduling validation...');
    scheduleValidation(false);
  });

  // 3. Aussi écouter cart:refresh (dispatché par d'autres scripts custom)
  document.addEventListener('cart:refresh', function() {
    console.log('[BRACELET-VALID] cart:refresh detected, scheduling validation...');
    scheduleValidation(false);
  });
})();
